import React from "react";
import "./styles.css"


export const InsutryPartsTableHeader = ({ header, name, handleChanges, placeholder, handleSortClick }) => {

  return (
    <th className="cursor">
      <ul className="navbar-nav">
        <li className="dropdown">
          <a className="dropdown-toggle" data-bs-toggle="dropdown">
            {header}
          </a>
          <ul className="dropdown-menu p-3" aria-labelledby="navbarDarkDropdownMenuLink">
            <li className="pb-3">
              <input placeholder={placeholder} name={name} onChange={handleChanges}/>
            </li>
            <li>
              <button
                className="btn btn-outline-dark w-100 p-0"
                onClick={() => handleSortClick(name)}
              >
                Ordenar A - Z
              </button >
            </li>
          </ul>
        </li>
      </ul>
    </th>
  );
}
